var exports = {
  "k": "xdde3148b--fd9672--container",
  "E": "xdde3148b--fd9672--scrollable",
};

module.exports = exports;
